<template>
  <svg
    class="select-input-arrow"
    width="13"
    height="8"
    viewBox="0 0 13 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.4776 2.19209C12.8681 1.80156 12.8681 1.1684 12.4776 0.777874C12.0871 0.38735 11.4539 0.38735 11.0634 0.777874L12.4776 2.19209ZM6.72839 6.5271L6.02128 7.23421C6.41181 7.62473 7.04497 7.62473 7.4355 7.23421L6.72839 6.5271ZM2.38113 0.765623C1.9906 0.375099 1.35744 0.375099 0.966913 0.765623C0.576389 1.15615 0.576389 1.78931 0.966913 2.17984L2.38113 0.765623ZM11.0634 0.777874L6.02128 5.81999L7.4355 7.23421L12.4776 2.19209L11.0634 0.777874ZM7.4355 5.81999L2.38113 0.765623L0.966913 2.17984L6.02128 7.23421L7.4355 5.81999Z"
      fill="#81807F"
    />
  </svg>
</template>

<script>
export default {
  name: "svg-select-input-arrow",
};
</script>
